"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableWrapper = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
exports.TableWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 60rem;\n  height: 58.2rem;\n  padding: 0 2.4rem 1.2rem 2.4rem;\n"], ["\n  width: 60rem;\n  height: 58.2rem;\n  padding: 0 2.4rem 1.2rem 2.4rem;\n"])));
var templateObject_1;
